import React from 'react';
import { Line } from 'react-chartjs-2';
import { formatPeriodId, lineChartOptions } from './analyticsFormat';
import { AppliedRangeSummary } from './AnalyticsStatus';
import { registerAdminCharts } from './registerAdminCharts';

registerAdminCharts();

export default function GrowthChartSection({
  dailyUsersData,
  palette,
  analyticsRangePreset,
  growthRangeApplied,
  lastUpdatedAt,
}) {
  return (
    <div className="chart">
      <div>
        <h2 style={{ marginBottom: 6 }}>Daily User Growth</h2>
        <div style={{ fontSize: 13, color: 'var(--vx-admin-muted)' }}>
          <AppliedRangeSummary
            analyticsRangePreset={analyticsRangePreset}
            growthRangeApplied={growthRangeApplied}
          />
          {lastUpdatedAt ? (
            <span style={{ marginLeft: 12 }}>Last updated: {lastUpdatedAt.toLocaleString()}</span>
          ) : null}
        </div>
      </div>
      <Line data={dailyUsersData} options={lineChartOptions(palette)} />
    </div>
  );
}

export function PeriodGrowthTables({ weekly = [], monthly = [] }) {
  return (
    <div className="admin-period-grid">
      <div className="chart" style={{ minHeight: 0 }}>
        <h2>Weekly signups</h2>
        <p className="adminMutedText" style={{ marginTop: 0, fontSize: 13 }}>Last 12 weeks. Not filtered by the date window above.</p>
        {weekly.length ? (
          <div className="geo-table">
            <table>
              <thead>
                <tr>
                  <th>Week</th>
                  <th>New users</th>
                </tr>
              </thead>
              <tbody>
                {weekly.slice(-12).map((row, index) => (
                  <tr key={`${formatPeriodId(row._id, 'week')}-${index}`}>
                    <td>{formatPeriodId(row._id, 'week')}</td>
                    <td>{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="adminMutedText">No weekly signup data.</p>
        )}
      </div>
      <div className="chart" style={{ minHeight: 0 }}>
        <h2>Monthly signups</h2>
        <p className="adminMutedText" style={{ marginTop: 0, fontSize: 13 }}>Last 12 months. Not filtered by the date window above.</p>
        {monthly.length ? (
          <div className="geo-table">
            <table>
              <thead>
                <tr>
                  <th>Month</th>
                  <th>New users</th>
                </tr>
              </thead>
              <tbody>
                {monthly.slice(-12).map((row, index) => (
                  <tr key={`${formatPeriodId(row._id, 'month')}-${index}`}>
                    <td>{formatPeriodId(row._id, 'month')}</td>
                    <td>{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="adminMutedText">No monthly signup data.</p>
        )}
      </div>
    </div>
  );
}
